import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getOneCropNutrition } from 'api/requests';

export const fetchOneCropNutrition = createAsyncThunk(
    'oneCropNutrition/fetchOneCropNutrition',
    async ({ slug, language = 'en', country = 'en' } = {}) => {
        try {
            const response = await getOneCropNutrition(slug, language, country);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
);

const oneCropNutritionSlice = createSlice({
    name: 'oneCropNutrition',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchOneCropNutrition.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOneCropNutrition.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchOneCropNutrition.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default oneCropNutritionSlice.reducer;
